import styled from 'styled-components';
import { colors, Grid } from '@dexma/ui-components';

export const StyledPanelDataSet = styled(Grid)`
    padding: 0 30px;
    .title {
        color: ${colors.gray500};
        font-size: 16px;
    }
    .widget-type-block {
        margin-top: 30px;
    }
`;
